import script from "./companionGroups.vue?vue&type=script&setup=true&lang=ts"
export * from "./companionGroups.vue?vue&type=script&setup=true&lang=ts"

import "./companionGroups.vue?vue&type=style&index=0&id=3fba80a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fba80a4"]])

export default __exports__